import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { FlexBox, Spacer } from '../layout';

interface SectionLoaderProps {
  isLoading: boolean;
  title: string;
}

const SectionLoader: React.FC<SectionLoaderProps> = ({ isLoading, title }) =>
  isLoading && (
    <FlexBox
      flexDirection={'column'}
      alignItems={'center'}
      color={'primary'}
      gap={3}
      height={'100%'}
    >
      <Spacer height={'2rem'} />
      <CircularProgress size={'1.5rem'} color="primary" />
      <Typography variant="subtitle2">{title}</Typography>
    </FlexBox>
  );

export default SectionLoader;
